import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3e17d2df"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/mahalo_integrador/hiopos/reports-co/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e17d2df')) {
      api.createRecord('3e17d2df', component.options)
    } else {
      api.reload('3e17d2df', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=3e17d2df", function () {
      api.rerender('3e17d2df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/Index.vue"
export default component.exports